module.exports = __webpack_public_path__ + "media/images/element/app-store-d2211884787c3d89ef518f532f66f1ec.svg";